module.exports = __webpack_public_path__ + "static/media/a3.dac3fdbb.jpeg";